// @flow
import React, { type Node } from 'react';
import styled, { type StyledComponent } from 'styled-components';
import classNames from 'classnames';

import { DSToken, Spacing } from '@rover/react-lib/styles';
import { SENSITIVE_DATA_CLASS } from '@rover/react-lib/constants/sensitiveData.constants';

export const Wrapper: StyledComponent<{}> = styled(({ children, ...props }) =>
  React.cloneElement(children, props)
)`
  height: 40px;
  width: 100%;
  background-color: ${DSToken.BACKGROUND_COLOR_PRIMARY};
  border-radius: ${DSToken.BORDER_RADIUS};
  border: 1px solid ${DSToken.BORDER_COLOR_PRIMARY};
  color: ${DSToken.TEXT_COLOR_PRIMARY};
  display: block;
  padding: ${Spacing.S};
  transition: border-color ease-in-out 0.15s;

  &:focus {
    border: 1px solid ${DSToken.BORDER_COLOR_INPUT_FOCUS};
    outline: none;
  }

  &:disabled {
    background-color: ${DSToken.INTERACTIVE_BACKGROUND_COLOR_DISABLED};
    border: 1px solid ${DSToken.INTERACTIVE_BORDER_COLOR_DISABLED};
    cursor: not-allowed;
    opacity: 1;
  }
`;

type InputRef = (?any) => void;

type InputProps = {
  className: string,
  onChange: (SyntheticInputEvent<HTMLInputElement>) => void,
  ref?: InputRef,
};

export type Props = {
  children: InputProps => Node,
  inputRef?: InputRef,
  onChange: string => void,
  sensitive?: boolean,
  className?: string,
};

const getClassNames = (sensitive, className) =>
  classNames(className, {
    [SENSITIVE_DATA_CLASS]: sensitive,
  });

const AsInput = (props: Props): Node => {
  const { children, className, inputRef, onChange, sensitive } = props;

  const inputProps: InputProps = {
    className: getClassNames(sensitive, className),
    onChange: event => onChange(event.target.value),
  };

  if (inputRef) {
    inputProps.ref = inputRef;
  }

  return <Wrapper className={getClassNames(sensitive, className)}>{children(inputProps)}</Wrapper>;
};

AsInput.defaultProps = {
  className: '',
  inputRef: undefined,
  onChange() {},
  sensitive: false,
};

export default AsInput;



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/AsInput/AsInput.jsx